module.exports = __webpack_public_path__ + "static/media/10863796_10205657354493673_3348099862841649486_o.4754817f.jpg";